<ng-container *ngFor="let doc of docs; let l = last">
  <ib-selected-doc
    class="block border-b border-border-d last:border-b-0"
    [ngClass]="[docs.length > 1 ? 'py-16px' : '']"
    [docForm]="docsFormGroupsMap?.[doc.id]"
    [document]="doc"
    (removeMe)="removeDoc?.emit($event)"
  >
  </ib-selected-doc>
</ng-container>
